import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const salesEnquiryStore = {
    namespaced: true,
    actions:{
        getSalesTransactionEnquiry({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/salestransaction', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        salesTarget({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/SO/SalesTarget', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        saveSalesTarget({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/SO/SaveSalesTarget', JSON.stringify({ salesTargets: param.salesTargets })).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getSalesTransactionEnquiryDetails({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/SalesTransactionByItem', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getOutstandingSOEnquiry({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/SO/OutstandingSOTable', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        exportFile({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/mm/export', state.q, {responseType : 'blob'}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default salesEnquiryStore;